import react from 'React'
const settings = wc.wcSettings.getPaymentMethodData('ipgw_invoice_gateway')
import TextField from './TextField'
import PoField from './PoField'
const EditComponent = (props) => {
	return(
		<>
			<span>{settings.description}</span>
			<PoField is_enabled={settings.po_field_enabled}/>
			<TextField is_enabled={settings.text_field_enabled}/>
			<span>{settings.rule_description}</span>
		</>
	)
}

export default EditComponent